// ============================================================================
// JAMB Learn Content — Chemistry
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_CHEMISTRY_LEARN_SS1 } from '../../waec/learn/ss1/chemistry';
import { WAEC_CHEMISTRY_LEARN_SS2 } from '../../waec/learn/ss2/chemistry';
import { WAEC_CHEMISTRY_LEARN_SS3 } from '../../waec/learn/ss3/chemistry';

export const JAMB_LEARN_CHEMISTRY = [
  ...WAEC_CHEMISTRY_LEARN_SS1,
  ...WAEC_CHEMISTRY_LEARN_SS2,
  ...WAEC_CHEMISTRY_LEARN_SS3,
];
